import {UserRoles} from "../../helpers/userRoles";
import AddPrice from "../components/addPrice/addPrice";
import ModifyPrice from "../components/modifyPrice/modifyPrice";
import PriceList from "../components/priceList/priceList";

export enum priceListRoutingAddress {
    list = "/price-list/list",
    add = "/price-list/add-price",
    modify = "/price-list/modify-price",
}

export const priceListRoutes = [
    {
        path: priceListRoutingAddress.list,
        component: PriceList,
        roles: [UserRoles.priceListViewAndModification]
    },
    {
        path: priceListRoutingAddress.add,
        component: AddPrice,
        roles: [UserRoles.priceListViewAndModification]
    },
    {
        path: `${priceListRoutingAddress.modify}/:id`,
        component: ModifyPrice,
        roles: [UserRoles.priceListViewAndModification]
    }
];
